import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.744 23.259c5.934 0 10.744-4.81 10.744-10.745 0-5.933-4.81-10.743-10.744-10.743S1 6.58 1 12.515c0 5.933 4.81 10.744 10.744 10.744ZM19.96 20.31l5.056 5.056M7.321 12.515h8.848",
  stroke: "#000",
  "stroke-width": "1.896",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }